import { __assign, __awaiter, __extends, __generator, __rest } from "tslib";
import { CartEvents, GraphQLOperations, RestCommands, RemoteSourceTypes } from '../constants';
import { TrackEventName } from '@wix/wixstores-client-core/dist/es/src/types/track-event';
import { query as getCartServiceQuery } from '../../graphql/getCartService.graphql';
import { query as getCartQuery } from '../../graphql/getCart.graphql';
import { query as createCheckoutFromCartMutation } from '../../graphql/createCheckoutFromCart.graphql';
import { query as setCartSelectedShippingOption } from '../../graphql/setCartSelectedShippingOption.graphql';
import { query as setDestinationForEstimation } from '../../graphql/setDestinationForEstimation.graphql';
import { query as addToCartMutation } from '../../graphql/addToCart.graphql';
import { query as addToCartWixCodeMutation } from '../../graphql/addToCartWixCode.graphql';
import { query as setCouponMutation } from '../../graphql/setCoupon.graphql';
import { query as removeCouponMutation } from '../../graphql/removeCoupon.graphql';
import { query as updateBuyerNoteMutation } from '../../graphql/updateBuyerNote.graphql';
import { query as removeCartItemMutationQuery } from '../../graphql/removeCartItem.graphql';
import { query as updateCartItemQuantityQuery } from '../../graphql/updateCartItemQuantity.graphql';
import { compact } from '../../lib/compact';
import { BaseApi } from '../BaseApi';
import { actualPrice, actualSku } from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import { CheckoutLegacyApi } from '../CheckoutLegacyApi/CheckoutLegacyApi';
import { mapCommandAddressToCheckoutLegacyAddress } from '../helpers/mapCommandAddressToCheckoutAddress';
import { ChannelType, } from '@wix/wixstores-graphql-schema-node/dist/src/graphql-schema';
import { SPECS } from '../../constants';
import _ from 'lodash';
import { graphqlCartToCartSummary } from './graphqlCartToCartSummary';
var CartApi = /** @class */ (function (_super) {
    __extends(CartApi, _super);
    function CartApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CartApi.prototype, "checkoutLegacyApi", {
        get: function () {
            return new CheckoutLegacyApi({ siteStore: this.siteStore, origin: this.origin });
        },
        enumerable: false,
        configurable: true
    });
    CartApi.prototype.commandPost = function (command, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.post(this.endpoints.cartCommmands(command), data)];
            });
        });
    };
    CartApi.prototype.createCheckout = function (cartId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: { params: { cartId: cartId, channelType: ChannelType.WEB } },
                            query: createCheckoutFromCartMutation,
                            operationName: GraphQLOperations.CreateCheckout,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).cart.createCheckout.checkoutId];
                }
            });
        });
    };
    CartApi.prototype.addToCart = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: { params: params },
                            query: addToCartMutation,
                            operationName: GraphQLOperations.AddToCart,
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).cart.addToCart.cart];
                }
            });
        });
    };
    CartApi.prototype.addToCartWixCode = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cartResponse, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mutate({
                            variables: { params: params },
                            query: addToCartWixCodeMutation,
                            operationName: GraphQLOperations.AddToCartWixCode,
                        }, function (response) { return _.get(response, 'data.cart.addToCartWixCode.errors[0].message', null); })];
                    case 1:
                        cartResponse = _a.sent();
                        cart = cartResponse.cart.addToCartWixCode.cart;
                        cart && this.publishCartChange(graphqlCartToCartSummary(cart), true);
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CartApi.prototype.fetchCart = function (variables) {
        if (variables === void 0) { variables = { locale: 'en', withTax: false, withShipping: false }; }
        return __awaiter(this, void 0, void 0, function () {
            var response_1, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.GET_CART_PLATFORM)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetch({
                                variables: variables,
                                query: getCartQuery,
                                operationName: GraphQLOperations.GetCart,
                            }, RemoteSourceTypes.NodeReadWrite, true)];
                    case 1:
                        response_1 = _a.sent();
                        return [2 /*return*/, response_1.data.cart];
                    case 2: return [4 /*yield*/, this.fetch({
                            variables: variables,
                            query: getCartServiceQuery,
                            operationName: GraphQLOperations.GetCartService,
                        })];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, response.data.cartService.cart];
                }
            });
        });
    };
    CartApi.prototype.removeItemMutation = function (cartId, cartItemId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = { cartId: cartId, cartItemId: cartItemId };
                return [2 /*return*/, this.mutate({
                        variables: { params: params },
                        query: removeCartItemMutationQuery,
                        operationName: GraphQLOperations.RemoveItem,
                    })];
            });
        });
    };
    CartApi.prototype.removeItem = function (_a, biData) {
        var cartId = _a.cartId, cartItemId = _a.cartItemId;
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary, cart, product;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.USE_CART_REMOVE_ITEM_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.removeItemMutation(cartId, cartItemId)];
                    case 1:
                        cart = (_b.sent()).cart.removeItem.cart;
                        cartSummary = graphqlCartToCartSummary(cart);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.postAndReturnCartSummary(RestCommands.CartRemoveItem, { cartItemId: cartItemId })];
                    case 3:
                        cartSummary = _b.sent();
                        _b.label = 4;
                    case 4:
                        this.publishCartChange(cartSummary);
                        if (biData) {
                            product = biData.item.product;
                            this.biService.removeItem(biData.cart, product);
                            this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
                                id: product.id,
                                name: product.name,
                                price: actualPrice(product),
                                quantity: biData.item.quantity,
                                sku: actualSku(product),
                                currency: biData.cart.convertedCurrencyFormat.code,
                                type: product.productType,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.updateItemQuantityMutation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mutate({
                        variables: { params: params },
                        query: updateCartItemQuantityQuery,
                        operationName: GraphQLOperations.UpdateItemQuantity,
                    })];
            });
        });
    };
    CartApi.prototype.updateItemQuantity = function (data, biData) {
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary, cart, _cartId, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (biData) {
                            this.biService.updateItemQuantity(biData.cart, biData.productId);
                        }
                        if (!this.siteStore.experiments.enabled(SPECS.USE_CART_UPDATE_ITEM_QUANTITY_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateItemQuantityMutation(data)];
                    case 1:
                        cart = (_a.sent()).cart.updateItemQuantity.cart;
                        cartSummary = graphqlCartToCartSummary(cart);
                        return [3 /*break*/, 4];
                    case 2:
                        _cartId = data.cartId, params = __rest(data, ["cartId"]);
                        return [4 /*yield*/, this.postAndReturnCartSummary(RestCommands.CartUpdateItem, params)];
                    case 3:
                        cartSummary = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.publishCartChange(cartSummary);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.updateBuyerNoteMutation = function (cartId, buyerNote) {
        if (buyerNote === void 0) { buyerNote = ''; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.mutate({
                        variables: { params: { cartId: cartId, buyerNote: buyerNote } },
                        query: updateBuyerNoteMutation,
                        operationName: GraphQLOperations.UpdateBuyerNote,
                    })];
            });
        });
    };
    CartApi.prototype.updateBuyerNote = function (data, _a) {
        var cart = _a.cart;
        return __awaiter(this, void 0, void 0, function () {
            var note;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.USE_CART_UPDATE_BUYER_NOTE_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateBuyerNoteMutation(cart.cartId, data.content)];
                    case 1:
                        _b.sent();
                        this.biService.updateBuyerNote(cart, !!data.content);
                        return [2 /*return*/];
                    case 2:
                        note = compact(data);
                        return [4 /*yield*/, this.commandPost(RestCommands.CartUpdateBuyerNote, note)];
                    case 3:
                        _b.sent();
                        this.biService.updateBuyerNote(cart, !!note.content);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setDestinationForEstimation = function (data, cartId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.USE_SET_DESTINATION_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mutate({
                                variables: { params: { cartId: cartId, address: data.destination } },
                                query: setDestinationForEstimation,
                                operationName: GraphQLOperations.SetDestinationForEstimation,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.commandPost(RestCommands.CartSetCartDestinationForEstimation, data)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartShippingAddressesForFastFlowEstimation = function (cartId, address, checkoutId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutLegacyApi.setCartShippingAddressesForFastFlowEstimation({
                            cartId: cartId,
                            checkoutId: checkoutId,
                            address: {
                                country: address.country,
                                subdivision: address.subdivision,
                                zipCode: address.zipCode,
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartAddress = function (cartId, address, checkoutId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutLegacyApi.setCartAddressesAndDestinationFromSingleAddress({
                            cartId: cartId,
                            address: mapCommandAddressToCheckoutLegacyAddress(address),
                            checkoutId: checkoutId,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCartBillingAddress = function (cartId, billingAddress, checkoutId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkoutLegacyApi.setCartBillingAddress({
                            cartId: cartId,
                            address: mapCommandAddressToCheckoutLegacyAddress(billingAddress),
                            checkoutId: checkoutId,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setShippingOption = function (cartId, selectedShippingOption, checkoutId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.USE_SET_SHIPPING_OPTION_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mutate({
                                variables: { params: { cartId: cartId, selectedShippingOption: selectedShippingOption } },
                                query: setCartSelectedShippingOption,
                                operationName: GraphQLOperations.SetCartShippingOptionNew,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.checkoutLegacyApi.setCartShippingOption({ cartId: cartId, selectedShippingOption: selectedShippingOption, checkoutId: checkoutId })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.setCouponMutation = function (cartId, code, userIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var params, cart, maybeErrors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { cartId: cartId, code: code, userIdentifier: userIdentifier };
                        return [4 /*yield*/, this.mutate({
                                variables: { params: params },
                                query: setCouponMutation,
                                operationName: GraphQLOperations.SetCoupon,
                            })];
                    case 1:
                        cart = (_a.sent()).cart;
                        maybeErrors = cart.setCoupon.errors;
                        if (Array.isArray(maybeErrors) && maybeErrors.length > 0) {
                            // eslint-disable-next-line @typescript-eslint/no-throw-literal
                            throw { success: false, errors: maybeErrors };
                        }
                        return [2 /*return*/, cart.setCoupon.cart];
                }
            });
        });
    };
    CartApi.prototype.applyCoupon = function (cartId, code, userIdentifier, biData) {
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (biData) {
                            this.biService.applyCoupon(biData.cart, code, biData.isMember);
                        }
                        if (!this.siteStore.experiments.enabled(SPECS.USE_SET_COUPON_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setCouponMutation(cartId, code, userIdentifier)];
                    case 1:
                        cart = _a.sent();
                        cartSummary = graphqlCartToCartSummary(cart);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.postAndReturnCartSummary(RestCommands.CartApplyCoupon, { code: code })];
                    case 3:
                        cartSummary = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.publishCartChange(cartSummary);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.removeCoupon = function (_a, biData) {
        var cartId = _a.cartId, couponId = _a.couponId;
        return __awaiter(this, void 0, void 0, function () {
            var cartSummary, cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (biData) {
                            this.biService.removeCoupon(biData.cart, biData.isMember);
                        }
                        if (!this.siteStore.experiments.enabled(SPECS.USE_REMOVE_COUPON_GRAPHQL_MUTATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mutate({
                                variables: { params: { cartId: cartId, couponId: couponId } },
                                query: removeCouponMutation,
                                operationName: GraphQLOperations.RemoveCoupon,
                            })];
                    case 1:
                        cart = (_b.sent()).cart.removeCoupon.cart;
                        cartSummary = graphqlCartToCartSummary(cart);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.postAndReturnCartSummary(RestCommands.CartRemoveCoupon, { id: couponId })];
                    case 3:
                        cartSummary = _b.sent();
                        _b.label = 4;
                    case 4:
                        this.publishCartChange(cartSummary);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.deleteCart = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.commandPost(RestCommands.CartDelete, data)];
                    case 1:
                        _a.sent();
                        this.siteStore.pubSubManager.publish(CartEvents.Cleared, data, false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CartApi.prototype.postAndReturnCartSummary = function (command, data) {
        return this.commandPost(command, data).then(function (res) { return res.cartSummary; });
    };
    CartApi.prototype.publishCartChange = function (cartSummary, shouldOpenCart) {
        if (shouldOpenCart === void 0) { shouldOpenCart = false; }
        var billingAddress = cartSummary.billingAddress, shippingAddress = cartSummary.shippingAddress, sanitizedCartSummary = __rest(cartSummary, ["billingAddress", "shippingAddress"]);
        this.siteStore.pubSub.publish(CartEvents.Changed, __assign(__assign({}, sanitizedCartSummary), { eventOptions: { shouldOpenCart: shouldOpenCart }, extraParams: { origin: this.origin } }), false);
    };
    CartApi.prototype.placeOrder = function (_a) {
        var cartId = _a.cartId, checkoutId = _a.checkoutId, rest = __rest(_a, ["cartId", "checkoutId"]);
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.checkoutLegacyApi.submitPayment(__assign({ cartId: cartId,
                        checkoutId: checkoutId }, rest))];
            });
        });
    };
    return CartApi;
}(BaseApi));
export { CartApi };
//# sourceMappingURL=CartApi.js.map